export default function CTA() {
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    
    const data: Record<string, string> = {};
    formData.forEach((value, key) => {
      data[key] = value.toString();
    });

    try {
      const response = await fetch('https://readdy.ai/api/form/d5j0avk2hurhq8mi53ag', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(data).toString(),
      });

      if (response.ok) {
        const successMessage = document.createElement('div');
        successMessage.className = 'fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white rounded-2xl p-6 sm:p-8 shadow-2xl z-50 max-w-md w-full mx-4';
        successMessage.innerHTML = `
          <div class="text-center">
            <div class="w-14 h-14 sm:w-16 sm:h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <i class="ri-check-line text-2xl sm:text-3xl text-green-600"></i>
            </div>
            <h3 class="text-xl sm:text-2xl font-bold text-[#1a2b4a] mb-3 sm:mb-4">お申し込みありがとうございます！</h3>
            <p class="text-sm sm:text-base text-gray-600 mb-4 sm:mb-6">担当者より24時間以内にご連絡いたします。</p>
            <button onclick="this.parentElement.parentElement.remove()" class="bg-[#ff8c42] text-white px-6 sm:px-8 py-2.5 sm:py-3 rounded-full font-bold hover:bg-[#ff7a2e] transition-all cursor-pointer text-sm sm:text-base">
              閉じる
            </button>
          </div>
        `;
        document.body.appendChild(successMessage);
        form.reset();
      } else {
        throw new Error('送信失敗');
      }
    } catch (error) {
      const errorMessage = document.createElement('div');
      errorMessage.className = 'fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white rounded-2xl p-6 sm:p-8 shadow-2xl z-50 max-w-md w-full mx-4';
      errorMessage.innerHTML = `
        <div class="text-center">
          <div class="w-14 h-14 sm:w-16 sm:h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <i class="ri-close-line text-2xl sm:text-3xl text-red-600"></i>
          </div>
          <h3 class="text-xl sm:text-2xl font-bold text-[#1a2b4a] mb-3 sm:mb-4">送信に失敗しました</h3>
          <p class="text-sm sm:text-base text-gray-600 mb-4 sm:mb-6">お手数ですが、お電話でお問い合わせください。</p>
          <button onclick="this.parentElement.parentElement.remove()" class="bg-[#ff8c42] text-white px-6 sm:px-8 py-2.5 sm:py-3 rounded-full font-bold hover:bg-[#ff7a2e] transition-all cursor-pointer text-sm sm:text-base">
            閉じる
          </button>
        </div>
      `;
      document.body.appendChild(errorMessage);
    }
  };

  return (
    <section id="contact" className="py-16 sm:py-20 lg:py-24 bg-gradient-to-br from-[#1a2b4a] via-[#2a3b5a] to-[#1a2b4a] relative overflow-hidden">
      {/* Background Decoration */}
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-white/5 rounded-full blur-3xl"></div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 relative z-10">
        {/* Title */}
        <div className="text-center mb-8 sm:mb-12">
          <p className="text-base sm:text-xl text-gray-300 mb-3 sm:mb-4 px-2">まずは無料のご相談から</p>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4 sm:mb-6 px-2 leading-tight">
            満足いただけなければ、<br />遠慮なくお断りください
          </h2>
          <p className="text-sm sm:text-base lg:text-lg text-gray-200 leading-relaxed max-w-3xl mx-auto mb-6 sm:mb-8 px-4">
            私たちは、無理な営業は一切いたしません。<br />
            現地調査とお見積もりは完全無料。ご納得いただけない場合は、<br className="hidden sm:inline" />
            <strong className="text-[#ff8c42]">どうぞ遠慮なくお断りください。</strong><br />
            それでも、私たちの誠実さを感じていただけたら嬉しいです。
          </p>

          {/* Quick Contact Buttons */}
          <div className="flex flex-col gap-3 sm:gap-4 justify-center mb-8 sm:mb-12 px-4">
            <a 
              href="tel:047-401-0700"
              className="flex items-center justify-center gap-2 sm:gap-3 bg-[#ff8c42] text-white px-8 sm:px-10 py-4 sm:py-5 rounded-full text-base sm:text-lg font-bold hover:bg-[#ff7a2e] transition-all shadow-xl whitespace-nowrap cursor-pointer"
            >
              <div className="w-5 h-5 sm:w-6 sm:h-6 flex items-center justify-center bg-white/20 rounded-full">
                <i className="ri-phone-fill text-lg sm:text-xl"></i>
              </div>
              電話で無料相談する
            </a>
            <a 
              href="https://lin.ee/0Rgwq5v1"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center gap-2 sm:gap-3 bg-white text-[#1a2b4a] px-8 sm:px-10 py-4 sm:py-5 rounded-full text-base sm:text-lg font-bold hover:bg-gray-100 transition-all shadow-xl whitespace-nowrap cursor-pointer"
            >
              <div className="w-5 h-5 sm:w-6 sm:h-6 flex items-center justify-center">
                <i className="ri-line-fill text-lg sm:text-xl"></i>
              </div>
              LINEで無料相談する
            </a>
          </div>
        </div>

        {/* Contact Form */}
        <div className="bg-white rounded-2xl sm:rounded-3xl p-6 sm:p-8 lg:p-12 shadow-2xl">
          <h3 className="text-xl sm:text-2xl font-bold text-[#1a2b4a] mb-4 sm:mb-6 text-center px-2">
            無料現場調査 お申し込みフォーム
          </h3>
          
          <form id="contact-form" data-readdy-form onSubmit={handleSubmit} className="space-y-4 sm:space-y-6">
            <div className="grid md:grid-cols-2 gap-4 sm:gap-6">
              <div>
                <label className="block text-sm font-bold text-gray-700 mb-2">
                  お名前 <span className="text-red-500">*</span>
                </label>
                <input 
                  type="text"
                  name="name"
                  required
                  className="w-full px-3 sm:px-4 py-2.5 sm:py-3 border-2 border-gray-200 rounded-xl focus:border-[#ff8c42] focus:outline-none transition-colors text-sm sm:text-base"
                  placeholder="山田 太郎"
                />
              </div>
              
              <div>
                <label className="block text-sm font-bold text-gray-700 mb-2">
                  電話番号 <span className="text-red-500">*</span>
                </label>
                <input 
                  type="tel"
                  name="phone"
                  required
                  className="w-full px-3 sm:px-4 py-2.5 sm:py-3 border-2 border-gray-200 rounded-xl focus:border-[#ff8c42] focus:outline-none transition-colors text-sm sm:text-base"
                  placeholder="090-1234-5678"
                />
              </div>
            </div>

            <div>
              <label className="block text-sm font-bold text-gray-700 mb-2">
                メールアドレス <span className="text-red-500">*</span>
              </label>
              <input 
                type="email"
                name="email"
                required
                className="w-full px-3 sm:px-4 py-2.5 sm:py-3 border-2 border-gray-200 rounded-xl focus:border-[#ff8c42] focus:outline-none transition-colors text-sm sm:text-base"
                placeholder="example@email.com"
              />
            </div>

            <div>
              <label className="block text-sm font-bold text-gray-700 mb-2">
                ご住所（船橋市内） <span className="text-red-500">*</span>
              </label>
              <input 
                type="text"
                name="address"
                required
                className="w-full px-3 sm:px-4 py-2.5 sm:py-3 border-2 border-gray-200 rounded-xl focus:border-[#ff8c42] focus:outline-none transition-colors text-sm sm:text-base"
                placeholder="船橋市○○町○-○-○"
              />
            </div>

            <div>
              <label className="block text-sm font-bold text-gray-700 mb-2">
                ご希望の調査日時
              </label>
              <input 
                type="text"
                name="preferred_date"
                className="w-full px-3 sm:px-4 py-2.5 sm:py-3 border-2 border-gray-200 rounded-xl focus:border-[#ff8c42] focus:outline-none transition-colors text-sm sm:text-base"
                placeholder="例：平日午前中、土曜日14時以降など"
              />
            </div>

            <div>
              <label className="block text-sm font-bold text-gray-700 mb-2">
                ご相談内容・ご要望（500文字以内）
              </label>
              <textarea 
                name="message"
                rows={4}
                maxLength={500}
                className="w-full px-3 sm:px-4 py-2.5 sm:py-3 border-2 border-gray-200 rounded-xl focus:border-[#ff8c42] focus:outline-none transition-colors resize-none text-sm sm:text-base"
                placeholder="現在のお悩みやご要望をお聞かせください"
              ></textarea>
              <p className="text-xs sm:text-sm text-gray-500 mt-2">※500文字を超えると送信できません</p>
            </div>

            <button 
              type="submit"
              className="w-full bg-[#ff8c42] text-white py-4 sm:py-5 rounded-full text-base sm:text-lg font-bold hover:bg-[#ff7a2e] transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
            >
              無料現場調査を申し込む
            </button>
          </form>
        </div>

        {/* Signature */}
        <div className="text-center mt-8 sm:mt-12">
          <div className="inline-block bg-white/10 backdrop-blur-sm rounded-2xl px-6 sm:px-8 py-6 sm:py-6 max-w-2xl">
            <p className="text-sm sm:text-base text-gray-200 mb-3 sm:mb-4">
              受付時間：10:00-19:00（日月休み）
            </p>
            <p className="text-[#ff8c42] font-bold text-base sm:text-lg mb-3 sm:mb-4">
              24時間LINE受付中
            </p>
            <div className="border-t border-white/20 pt-3 sm:pt-4">
              <p className="text-white font-bold text-base sm:text-lg">
                代表取締役 吉原 将広
              </p>
              <p className="text-gray-300 text-xs sm:text-sm mt-2 leading-relaxed px-2">
                船橋市の皆様に、一生付き合えるパートナーとして選ばれ続けたい。<br className="hidden sm:inline" />
                その想いで、日々誠実な施工を心がけています。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
